export default "__VITE_PUBLIC_ASSET__cbe8784a__"